export default __webpack_public_path__ + "static/media/FreteOrange.91e1cfdf.svg";